import { Box } from '@mui/material';

const styles = {
  root: {
    width: '100%',
    height: '100%',
    display: 'block',
  },
};

const NeutralJerseyPlaceholder = () => {
  return (
    <Box component='svg' viewBox='0 0 64 64' aria-hidden='true' sx={styles.root}>
      <path
        d='M23 9.5 32 14l9-4.5 11 10-5.5 10-6.5-3V55H24V26.5l-6.5 3L12 19.5l11-10Z'
        fill='currentColor'
        opacity='0.92'
      />
      <path d='M28.5 15.5h7v39h-7z' fill='currentColor' opacity='0.28' />
      <path d='M20.5 17.5 24 26l8-4 8 4 3.5-8.5' fill='currentColor' opacity='0.18' />
      <path
        d='M23 9.5 32 14l9-4.5 11 10-5.5 10-6.5-3V55H24V26.5l-6.5 3L12 19.5l11-10Z'
        fill='none'
        stroke='currentColor'
        strokeOpacity='0.55'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
      <path d='M27 14.8h10' stroke='currentColor' strokeOpacity='0.42' strokeWidth='1.5' strokeLinecap='round' />
    </Box>
  );
};

export default NeutralJerseyPlaceholder;
